export enum SelfServeUITabEnum {
  HIRING = 'HIRING',
  ENGAGEMENTS_DASHBOARD = 'ENGAGEMENTS_DASHBOARD',
  TIMESHEETS = 'TIMESHEETS',
}
